/**
 * WP7a / #46615 — "Ask about this" object-page seed hook.
 *
 * Mounted from the verification shell chrome for finding/run/receipt/policy/
 * evidence detail routes. Seeds the dock via `excellent:ask-agent` when Copilot
 * is on; otherwise routes to Settings → Agents → Chat. Does not own terminal.
 */

import type { ReactNode } from "react";
import {
  activateChatEntryInWindow,
  chatEntryTitle,
  dispatchAskAbout,
  seedQueryForObject,
  type ChatObjectKind,
} from "./chat-entry";
import { useVerificationEnvOptional } from "./env-provider";
import { ActionButton } from "./ui";

export function AskAboutObject({
  kind,
  id,
  label,
  href,
  copilotEnabled,
  onNavigate,
}: {
  kind: ChatObjectKind;
  id: string;
  label?: string;
  href?: string;
  copilotEnabled: boolean;
  onNavigate: (to: string) => void;
}): ReactNode {
  const env = useVerificationEnvOptional();
  const query = seedQueryForObject({
    kind,
    id,
    label,
    environment: env?.environment ?? null,
    href,
  });

  return (
    <ActionButton
      actionId="util.chat"
      data-ask-about={kind}
      data-ask-about-id={id}
      data-copilot={copilotEnabled ? "on" : "off"}
      title={copilotEnabled ? `Ask about this ${kind}` : chatEntryTitle(false)}
      onClick={() => {
        if (!copilotEnabled) {
          activateChatEntryInWindow(false, onNavigate);
          return;
        }
        dispatchAskAbout(query);
      }}
    >
      Ask about this
    </ActionButton>
  );
}
